import IS_WEBRTC_SUPPORTED from '@environment/webrtcSupport';

const IS_CALL_SUPPORTED = IS_WEBRTC_SUPPORTED;

export default IS_CALL_SUPPORTED;
